import { render, staticRenderFns } from "./addNewCategory.vue?vue&type=template&id=2a17cb72"
import script from "./addNewCategory.vue?vue&type=script&lang=js"
export * from "./addNewCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports